<template>
    <div class="auditResult">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="body">
            <div>
                <img :src="failUrl" alt="">
                <div class="result">{{ type ? '认证失败' : '开户失败' }}</div>
                <p v-show="openInfo.failureReason" class="errtips">失败原因：{{ openInfo.failureReason }}</p>
            </div>
            <button @click="clickHandle">{{ type ? '重新认证' : '重新开户' }}</button>
        </div>
    </div>
</template>

<script>
import Header from '../../common/header'
import { getOpenInfo } from '../api/payment'
export default {
    name: 'errorResult',
    data () {
        return {
            title: '开户结果',
            result: '实名开户失败',
            type: !!(this.$route.query.status == 4),
            failUrl: require('../../../assets/img/b2b/img_wrong.png'),
            openInfo: {
                failureReason: ''
            }
        }
    },
    components: {
        Header
    },
    methods: {
        onBack () {
            this.$router.replace({ path: '/b2b/company/index' })
        },
        clickHandle () {
            this.$router.push({ path: '/b2b/business/openStatus', query: { userType: this.openInfo.userType, openStatus: this.openInfo.openStatus } })
        },
        async getInfo () {
            const { data } = await getOpenInfo({
                companyCode: this.$route.query.companyCode
            })
            let openJson = JSON.parse(data.openAccountInfo)
            let bankJson = JSON.parse(data.bankAccountInfo)
            let dataJson = {
                ...openJson,
                ...bankJson
            }
            localStorage.setItem('openAccountInfo', JSON.stringify(dataJson))
            this.openInfo = data
        }
    },
    created () {
        this.getInfo()
    }
}
</script>

<style lang="scss" scoped>
.auditResult {
    height: 100%;
    background-color: #fff;
}
.body {
    margin-top: 120px;
    text-align: center;
    img {
        width: 144px;
        height: 144px;
    }
    .result {
        color: #000000;
        font-size: 36px;
        font-weight: 400;
        margin: 48px 0 16px 0;
    }
    .tips {
        color: #8e8e93;
        font-size: 28px;
        font-weight: 400;
    }
    .errtips {
        color: #FF3B30;
        font-size: 28px;
        font-weight: 400;
        margin-bottom: 20px;
    }
    button {
        padding: 26px 200px;
        color: #ff7a45;
        border: 2px solid #ff7a45;
        border-radius: 40px;
        background-color: #fff;
        margin-top: 102px;
    }
}
</style>